import React, { useContext, useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import { Button, Select } from 'antd'
import { UpOutlined, DownOutlined } from '@ant-design/icons'

import GeneralContext from '../../context/GeneralContext/GeneralContext';

import api from '../../services/api';
import SL_Date from '../../components/dates/Date';
import { DateTime } from 'luxon';
import SL_Button from '../../components/buttons/Button';
import { SL_AutoCompleteSelect } from '../../components/selects/SL_AutoCompleteSelect';
import moment from 'moment';
import { displayMessage } from '../../services/helper';

export default function DashboardFilters({ loadEvoMonitoryChart, loadEvoExerciseChart, loadEvoGroupingChart, loadGroupingLevelChart, loadPatientScoreChart, nextFriday, nextMonday }) {

    const [dentists, setDentists] = useState([])
    const [currentFilters, setCurrentFilters] = useState({})
    const [isFiltersVisable, setIsFiltersVisable] = useState(true)

    const {
        setShowLoading,
        mobile_mode,
        user
    } = useContext(GeneralContext)

    useEffect(
        () => {
            loadDentists()
            setCurrentFilters({ ...currentFilters, start_date: moment(nextMonday).format('YYYY-MM-DD'), end_date: moment(nextFriday).format('YYYY-MM-DD') })
        }
        , []
    )

    const loadDentists = () => {
        setShowLoading(true)

        api.dentist.list().then(
            rs => {
                setDentists(rs.data)
                setShowLoading(false)
            }
        )
    }

    let populatePatientsTimeout;

    async function fetchPatientList(value) {
        return new Promise((resolve) => {
            clearTimeout(populatePatientsTimeout);
            populatePatientsTimeout = setTimeout(async () => {
                const patientList = (await api.patient.list({ find: value, limit_to_x_registers: 10 })).data
                const options = []
                patientList.map(patient => {
                    const alreadyUsed = options.find(e => e.value == patient.full_name)
                    if (!alreadyUsed) {
                        let option = {
                            key: patient.id,
                            label: patient.full_name,
                            value: patient.full_name,
                        }
                        options.push(option)
                    }
                })
                
                resolve(options);
            }, 1000)
        })
    }

    async function filterData() {
        try {
            setShowLoading(true);
            await loadEvoMonitoryChart(currentFilters);
            await loadEvoExerciseChart(currentFilters);
            // await loadEvoGroupingChart(currentFilters);
            await loadGroupingLevelChart(currentFilters);
            await loadPatientScoreChart(currentFilters);
            setShowLoading(false);
        } catch (error) {
            console.log(error);
            setShowLoading(false);
        }
    }

    return (
        <div
            style={
                {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    padding: 0,
                    marginBottom: 15,
                    color: 'white',
                    overflow: 'hidden',
                    border: '1px solid lightgrey',
                }
            }
        >
            <div className='flex flex-1 justify-between p-2 bg-appian-blue gap-1'>
                <span className='self-center font-medium text-white flex-1 text-center'>{displayMessage('APPOINTMENT_FILTERS')}</span>
                <SL_Button
                    style={{ background: 'white', borderColor: 'darkblue', color: 'black', fontWeight: 'bold' }}
                    className='items-center w-30 flex'
                    onClick={() => { isFiltersVisable ? setIsFiltersVisable(false) : setIsFiltersVisable(true) }}
                    shape="circle"
                    icon={isFiltersVisable ? <UpOutlined /> : <DownOutlined />}
                />
            </div>

            {
                isFiltersVisable &&
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, background: '#efefef' }}>

                    <div style={{ display: 'flex', flexDirection: mobile_mode ? `column` : `row`, flex: 1, flexWrap: 'wrap', padding: 5, alignItems: 'center' }}>
                        <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', flexWrap: 'wrap', flex: 1, rowGap: mobile_mode ? 5 : 0 }}>

                            <div style={{ display: 'flex', flexDirection: mobile_mode ? 'row' : 'column', marginRight: 5 }}>
                                <div style={{ fontWeight: 'bold', color: '#1b3663', marginRight: mobile_mode ? 10 : 0 }}>
                                    {displayMessage('DENTIST')}:
                                </div>
                                <Select
                                    style={{ width: mobile_mode ? 250 : 190 }}
                                    size="middle"
                                    value={currentFilters?.dentist_id}
                                    placeholder={user?.full_name}
                                    disabled
                                    allowClear={true}
                                >
                                </Select>
                            </div>

                            <div style={{ display: 'flex', flexDirection: mobile_mode ? 'row' : 'column', marginRight: 5 }}>
                                <div style={{ fontWeight: 'bold', color: '#1b3663', marginRight: mobile_mode ? 10 : 0 }}>
                                    {displayMessage('PATIENT')}:
                                </div>
                                <SL_AutoCompleteSelect
                                    onChange={newValue => {
                                        setCurrentFilters({
                                            ...currentFilters, patient_id: newValue.map(value => value.key)
                                        })
                                    }
                                    }
                                    placeholder={displayMessage('PATIENT')}
                                    fetchOptions={fetchPatientList}
                                />
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5 }}>
                                <div style={{ fontWeight: 'bold', color: '#1b3663', marginRight: mobile_mode ? 10 : 0 }}> ]
                                    {displayMessage('INITIAL_DATE')}:
                                </div>
                                <SL_Date
                                    placeholder={displayMessage('SELECT_DATE')}
                                    style={{ width: mobile_mode ? 160 : 200, }}
                                    format={'DD/MM/YYYY'}
                                    onChange={start_date => setCurrentFilters({ ...currentFilters, start_date: start_date?.format('YYYY-MM-DD') })}
                                    disabledDate={
                                        (current) => {
                                            return currentFilters.end_date ? current && current > DateTime.fromISO(currentFilters.end_date) : false
                                        }
                                    }
                                    defaultValue={moment(nextMonday)}
                                />
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5 }}>
                                <div style={{ fontWeight: 'bold', color: '#1b3663', marginRight: mobile_mode ? 10 : 0 }}> 
                                    {displayMessage('FINAL_DATE')}:
                                </div>
                                <SL_Date
                                    placeholder={displayMessage('SELECT_DATE')}
                                    style={{ width: mobile_mode ? 160 : 200, }}
                                    format={'DD/MM/YYYY'}
                                    onChange={end_date => setCurrentFilters({ ...currentFilters, end_date: end_date?.format('YYYY-MM-DD') })}
                                    disabledDate={
                                        (current) => {
                                            return currentFilters.start_date ? current && current < DateTime.fromISO(currentFilters.start_date) : false
                                        }
                                    }
                                    defaultValue={moment(nextFriday)}
                                />
                            </div>


                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: 5, alignItems: 'flex-end', marginTop: 10, padding: 5 }}>
                            <Button
                                onClick={() => filterData()}
                                type="primary"
                                style={{ marginRight: 5, width: 200, height: 40, fontWeight: 'bold', borderRadius: 7 }}
                            >
                                {displayMessage('SEARCH')}
                            </Button>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}


